import React from 'react';
import PropTypes from 'prop-types';
import { TranslatedBadge } from './translated_badge';

function SavePercentBadge({ percent, color }) {
    return (
        <TranslatedBadge
            type="save-percent"
            translationKey="badge-save-percent"
            placeholder={{ percent }}
            color={color}
        />
    );
}

SavePercentBadge.propTypes = {
    percent: PropTypes.number.isRequired
};

export { SavePercentBadge };
